import { useQuery } from '@tanstack/react-query';
import { roleApi } from '../api/role.api';
import { roleKeys } from '../api/role.keys';

export function useRoles() {
  return useQuery({
    queryKey: roleKeys.list(),
    queryFn: roleApi.list,
  });
}
